export const BILLBOARD_VENDOR_REQUESTS_STORAGE_KEY = 'vendor_billboard_requests';

export const defaultBillboardRequests = [
  {
    id: 'vendor-bb-request-1',
    producerName: 'Sarvam Maya Productions',
    campaignName: 'Sarvam Maya City Visibility Push',
    billboardTitle: 'MG Road LED Billboard',
    location: 'MG Road, Kochi, Kerala',
    mediaType: 'LED',
    size: '40 x 20 ft',
    requestedDuration: '14 days',
    startDate: '2026-04-08',
    budget: 85000,
    artwork: 'Sarvam-Maya-Outdoor-Key-Art.jpg',
    notes: 'Need the creative to go live before launch window. Priority is evening commuter visibility.',
    status: 'pending',
    requestedAt: '2026-04-04T09:30:00.000Z',
  },
  {
    id: 'vendor-bb-request-2',
    producerName: 'Studio Meridian',
    campaignName: 'Weekend Footfall Burst',
    billboardTitle: 'Lulu Highway Unipole',
    location: 'Edappally, Kochi, Kerala',
    mediaType: 'UNIPOLE',
    size: '50 x 25 ft',
    requestedDuration: '10 days',
    startDate: '2026-04-11',
    budget: 150000,
    artwork: 'Weekend-Burst-Billboard-Visual.png',
    notes: 'Looking for strong mall approach visibility with premium placement confirmation before payment.',
    status: 'pending',
    requestedAt: '2026-04-04T11:15:00.000Z',
  },
  {
    id: 'vendor-bb-request-3',
    producerName: 'Blueframe Entertainment',
    campaignName: 'Metro Corridor Preview Launch',
    billboardTitle: 'Ameerpet Metro Pillar Network',
    location: 'Ameerpet, Hyderabad, Telangana',
    mediaType: 'METRO PILLAR',
    size: 'Cluster of 12 pillars',
    requestedDuration: '7 days',
    startDate: '2026-04-10',
    budget: 68000,
    artwork: 'Preview-Metro-Pillar-Set.pdf',
    notes: 'Need fast turnaround. Creative is locked and ready for print adaptation.',
    status: 'pending',
    requestedAt: '2026-04-04T12:45:00.000Z',
  },
  {
    id: 'vendor-bb-request-4',
    producerName: 'Firefly Studios',
    campaignName: 'Launch Week City Domination',
    billboardTitle: 'Trivandrum Front Facade',
    location: 'Kowdiar, Thiruvananthapuram, Kerala',
    mediaType: 'FRONT FACADE',
    size: 'Building wrap',
    requestedDuration: '12 days',
    startDate: '2026-03-18',
    budget: 110000,
    artwork: 'Launch-Week-Facade-Master.jpg',
    notes: 'Campaign completed successfully with premium frontage visibility through launch week.',
    status: 'completed',
    requestedAt: '2026-03-05T10:15:00.000Z',
    reviewedAt: '2026-03-05T14:20:00.000Z',
    paymentReceivedAt: '2026-03-09T16:00:00.000Z',
  },
  {
    id: 'vendor-bb-request-5',
    producerName: 'North Star Pictures',
    campaignName: 'Weekend Family Audience Burst',
    billboardTitle: 'T Nagar Bus Shelter Circuit',
    location: 'T Nagar, Chennai, Tamil Nadu',
    mediaType: 'BUS SHELTER',
    size: '8 premium shelters',
    requestedDuration: '9 days',
    startDate: '2026-03-22',
    budget: 42000,
    artwork: 'Family-Burst-Shelter-Creative.png',
    notes: 'Payment received and shelters delivered across the full requested circuit.',
    status: 'completed',
    requestedAt: '2026-03-10T09:05:00.000Z',
    reviewedAt: '2026-03-10T12:10:00.000Z',
    paymentReceivedAt: '2026-03-14T11:35:00.000Z',
  },
];
